import Axios from '@/axios';

// 查询发票
export const GetInvoiceIndex = data => {
  return Axios({
    url: '/face/web/invoice-request/index',
    method: 'POST',
    type: 'json',
    data
  })
}
// 创建发票
export const CreateInvoice = data => {
  return Axios({
    url: '/face/web/invoice-request/create',
    method: 'POST',
    type: 'json',
    data
  })
}
// 修改发票参数
export const EditInvoice = data => {
  return Axios({
    url: `/face/web/invoice-request/change_param/${data.id}`,
    method: 'POST',
    type: 'json',
    data
  })
}

// 取消开票
export const CancelInvoice = id => {
  return Axios({
    url: `/face/web/invoice-request/cancle/${id}`,
    method: 'POST',
    type: 'json'
  })
}

// 获取历史发票抬头
export const CancelInvoiceTitle = () => {
  return Axios({
    url: `/face/web/invoice-request/index_last_use_param`,
    method: 'POST',
    type: 'json'
  })
}
